<template>
    <div>
         <table-custom v-if="id == 'identityField.table.custom'"></table-custom>

         <component-list-fields v-if="id == 'component.settings.list.fields'"></component-list-fields>
         <component-fields v-if="id == 'component.settings.fields'"></component-fields>

        <operation-mustache v-if="id == 'event.operation.mustache'"></operation-mustache>
        <recycle-ruleset v-if="id == 'event.recycle.ruleset'"></recycle-ruleset>
    </div>
</template>

<script>
import OperationMustache from './Events/OperationMustache.vue'
import TableCustom from './Fields/TableCustom.vue'
import ComponentListFields from './Components/ListFields'
import ComponentFields from './Components/Fields'
import RecycleRuleset from './Events/RecycleRuleset.vue'

export default {
  components: { 
      OperationMustache, 
      TableCustom, 
      ComponentListFields,
      ComponentFields,
      RecycleRuleset
    },
    props: {
        id: {
            type: String
        }
    }
}
</script>